module.exports = __webpack_public_path__ + "static/img/a015.1fd48e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a015.jpg
// module id = QPdg
// module chunks = 0